import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'ui-button-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui-button-group.component.html',
  styleUrl: './ui-button-group.component.scss'
})
export class UiButtonGroupComponent {
  /**
   * Full width on mobile
   */
  @Input() fullWidthMobile = false;

  /**
   * Size of buttons in the group
   */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  /**
   * Space between buttons.
   *
   * Note: DaisyUI's `btn-group` intentionally connects buttons (no gap).
   * Setting `gap` switches the container to a normal flex row with a Tailwind gap.
   */
  @Input() gap: 'none' | 'xs' | 'sm' | 'md' = 'xs';

  /**
   * Allow buttons to wrap to the next line (useful together with `gap`).
   */
  @Input() wrap = true;
}
